export default "__VITE_ASSET__D0W97VGB__"